module.exports = __webpack_public_path__ + "ba38f80de1e9b9c537cb1c305d59ee9a.png";